'use client';

import { JSX } from 'react';

import { GoogleLoginOneTouchButton } from '../../../components/google-login/GoogleLoginOneTouchButton';
import { useGoogleSignUpCallback } from './useGoogleSignUpCallback';

type Props = {
    planCode?: string;
};

export function GoogleSignUpButton({ planCode }: Props): JSX.Element | null {
    const callback = useGoogleSignUpCallback(planCode);
    if (typeof window === 'undefined') {
        return null;
    }
    return (
        <div className="flex flex-row items-center justify-center w-full">
            <GoogleLoginOneTouchButton successCallback={callback} />
        </div>
    );
}
